import { useState } from 'react';

export function useToggleDropdown(initialState: boolean) {
  const [showDropdown, setShowDropdown] = useState(initialState);
  const toggleDropdown = () => setShowDropdown((p) => !p);

  return { showDropdown, toggleDropdown, setShowDropdown };
}
